'use strict';

var Reflux = require('reflux');

var TranslationEditorActions = Reflux.createActions(["openEditor", "selectTranslation", "updateTranslation", "save", "cancel"]);

module.exports = TranslationEditorActions;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/actions/translation-editor.js
 **/